<section id="kkk-breadcrumb" class="row" *ngIf="parts.length">
    <ol class="breadcrumb col-12">
      <li class="breadcrumb-item"
          *ngFor="let part of parts; let last = last"
          [class.active]="last"
      >
        <a *ngIf="part.instructions" [routerLink]="part.instructions">{{ part.name }}</a>
        <span *ngIf="!part.instructions">{{ part.name }}</span>
      </li>
    </ol>
</section>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/components/breadcrumbs/breadcrumbs.component.html